<template>
	<div>
		<!-- logo 时间 -->
		<q-head></q-head>
		<!-- banner -->
		<qBanner></qBanner>
		
		
		
		<!-- 导航 3列的 -->
		<div class="nav-list">
			<ul>
				<li class="green">
					<a href="#/hospital-list">
						<div class="icon">
							<img src="../../assets/icon/icon-zyqd.png" >
						</div>
						<h3>住院清单</h3>
						<p>
							住院清单
						</p>
					</a>
				</li>
				<li class="green">
					<a href="#/shop-price">
						<div class="icon">
							<img src="../../assets/icon/icon-wjcx.png" >
						</div>
						<h3>物价查询</h3>
						<p>
							物价查询
						</p>
					</a>
				</li>
				<li class="green">
					<a href="#/about">
						<div class="icon">
							<img src="../../assets/icon/icon-yyjj.png" >
						</div>
						<h3>医院简介</h3>
						<p>
							医院简介
						</p>
					</a>
				</li>
				<li class="yellow">
					<a href="#/outpatient-department-list">
						<div class="icon">
							<img src="../../assets/icon/icon-mzqd.png" >
						</div>
						<h3>门诊清单</h3>
						<p>
							门诊清单
						</p>
					</a>
				</li>
				<li class="green">
					<a href="">
						<div class="icon">
							<img src="../../assets/icon/icon-jkda.png" >
						</div>
						<h3>健康档案</h3>
						<p>
							健康档案
						</p>
					</a>
				</li>
			</ul>
		</div>
		
		<a  class="btn-return fcc" @click="returnStep()">
			<img src="../../assets/icon/icon-return.png" >
			<span>返回</span>
		</a>
		
		
		<div class="footer fc-bet">
			<div>设备编号：1654FAS354    软件版本号：V2.1.0</div>
			<div>©2021  版权所有  软件公司名称</div>
		</div>
		
		
	</div>
</template>

<script>

	import qHead from '@/components/q-head/q-head.vue';
	import qBanner from '@/components/q-head/q-banner.vue';
	
	export default {
		components: {
			qHead,qBanner
		},
		data() {
			return {
				
			}
		},
		mounted() {
			
		},
		methods:{
			
		}
		
		
	}
</script>

<style scoped lang="less">
	.btn-return{
		position: absolute;
		left: 73px;
		bottom: 80px;
		width: 195px;
		height: 95px;
		background: #38BB8B;
		color: #fff;
		font-size: 30px;
		img{
			margin-right: 14px;
		}
	}
	.footer{
		position: absolute;
		left: 38px;
		right: 38px;
		font-size: 18px;
		bottom: 0;
		
		font-weight: 400;
		color: #000000;
		bottom: 6px;
		line-height: 38px;
		opacity: 0.5;
	}
.nav-list{
	ul{
		display: flex;
		padding-left: 75px;
		padding-top: 20px;
		flex-wrap: wrap;
	}
	li{
		width: 289px;
		height: 244px;
		background: #50A2FF;
		border-radius: 20px;
		margin-right: 36px;
		margin-bottom: 29px;
	}
	a{
		display: block;
		height: 244px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: relative;
	}
	.icon{
		width: 108px;
		height: 108px;
		display: flex;
		align-items: center;
		background: #fff;
		border-radius: 100px;
		justify-content: center;
	}
	h3{
		font-size: 30px;
		color: #fff;
		line-height: 50px;
	}
	.next{
		font-size: 46px;
		color: #fff;
	}
	p{
		font-size: 22px;
		line-height: 30px;
		font-weight: 500;
		color: #FFFFFF;
		
		opacity: 0.5;
	}
	.col2{
		width: 451px;
		a{
			display: block;
		}
		h3{
			padding-top: 20px;
			margin-bottom: 10px;
		}
		h3,p{
			padding-left: 34px;
		}
		.icon{
			position: absolute;
			right: 30px;
			top: 30px;
			background-color: #fff;
			border-radius: 150px;
		}
	}
	.yellow{
		background: #FF9537;
	}
	.green{
		background: #00B468;
	}
}

</style>
